import {
  GET_CONFIGURATION_MODELS_REQUESTED,
  GET_CONFIGURATION_MODELS_SUCCEEDED,
  GET_CONFIGURATION_MODELS_FAILED,
} from 'store/ConfigurationModels/constans'
import api from 'utils/api'

export const getConfigurationModelsRequested = () => ({
  type: GET_CONFIGURATION_MODELS_REQUESTED,
})

export const getConfigurationModelsSucceeded = (payload) => ({
  type: GET_CONFIGURATION_MODELS_SUCCEEDED,
  payload,
})

export const getConfigurationModelsFailed = () => ({
  type: GET_CONFIGURATION_MODELS_FAILED,
})

export const loadConfigurationModels = () => (dispatch) => {
  dispatch(getConfigurationModelsRequested())

  return api
    .fetchConfigurationModels()
    .then((response) => {
      dispatch(
        getConfigurationModelsSucceeded(
          response?.data?.configurationModels
        )
      )
    })
    .catch(() => {
      dispatch(getConfigurationModelsFailed())
    })
}
